const relativePathRegex = /^((https?:)?\/\/)?[^/]+/;

const getRelativePath = url => url.replace(relativePathRegex, '');

const endWithOrgIdRegex = /\/([0-9])+\/?$/;

const endWithOrgId = url => endWithOrgIdRegex.test(url);

export const isCurrentPage = (url, childrenUrls = [], currentUrl = window.location.href) => {
  if (endWithOrgId(url)) {
    return getRelativePath(url) === getRelativePath(currentUrl);
  }

  const childMatch = childrenUrls.some(childUrl => isCurrentPage(childUrl));
  return childMatch || getRelativePath(currentUrl).includes(getRelativePath(url));
};